export default "__VITE_ASSET__DQ2SMRLC__"